import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const brandsType = new RepositoryFactory('brandsType');

export default {
  namespaced: true,
  state: {
    // Single item
    brandType: {
      id: 0,
      name: '',
      answer: '',
      createdAt: '',
      updatedAt: '',
    },
    brandsTypes: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
    createError: '',
  },
  getters: {
    getBrandType(state) {
      return state.brandType;
    },
    getBrandsTypes(state) {
      for (const iterator of state.brandsTypes) {
        const date = new Date(iterator.createdAt);
        iterator.createdAt = date.toLocaleDateString('pt-BR');

        const updatedAt = new Date(iterator.updatedAt);
        iterator.updatedAt = updatedAt.toLocaleDateString('pt-BR');
      }

      return state.brandsTypes.map(s => ({
        id: s.id,
        name: s.name,
        answer: s.answer,
        createdAt: s.createdAt,
        updatedAt: s.updatedAt,
      }));
    },
    getBrandsTypeTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
    getError(state) {
      return state.error;
    },
    getCreateError(state) {
      if (state.createError) {
        return state.createError.message;
      } else {
        return '';
      }
    },
  },
  mutations: {
    SET_BRAND_TYPE(state, data) {
      state.brandType = data;
    },
    SET_BRANDS_TYPES(state, data) {
      state.brandsTypes = data.items;
      state.total = data.totalOfItems;
      state.totalPages = data.pageCount;
    },
    SET_ALL_BRANDS_TYPES(state, data) {
      state.brandsTypes = data;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getBrandsTypes');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getBrandsTypes');
    },
    update: async ({ dispatch }, payload) => {
      try {
        await brandsType.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Tipo de marca atualizado com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getBrandsTypes');
    },
    create: async ({ commit, dispatch }, payload) => {
      try {
        const res = await brandsType.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Tipo de marca criado com sucesso!',
        });
        dispatch('getBrandsTypes');
        return res.data.id;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
    },
    getBrandTypeById: async ({ commit }, id) => {
      try {
        const { data } = await brandsType.getById(id);
        commit('SET_BRAND_TYPE', data);
      } catch (error) {}
    },
    getBrandsTypes: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await brandsType.get(state.currentPage);
        commit('SET_BRANDS_TYPES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getBrandsTypesNoLimit: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await brandsType.get();
        commit('SET_ALL_BRANDS_TYPES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
